import { useState, useEffect } from 'react';
import { checkSetupStatus, type SetupStatus } from '@/services/driveApi';
import SetupWizard from '@/pages/setup/page';

interface SetupGuardProps {
  children: React.ReactNode;
}

export default function SetupGuard({ children }: SetupGuardProps) {
  const [status, setStatus] = useState<SetupStatus | null>(null);
  const [loading, setLoading] = useState(true);

  const check = async () => {
    setLoading(true);
    try {
      const result = await checkSetupStatus();
      setStatus(result);
    } catch {
      setStatus({ configured: true }); // if error, assume configured
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    check();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background-50">
        <div className="flex flex-col items-center gap-4">
          <div className="w-10 h-10 border-2 border-primary-500 border-t-transparent rounded-full animate-spin"></div>
          <p className="text-sm text-foreground-600">서버 연결 확인 중...</p>
        </div>
      </div>
    );
  }

  if (status && !status.configured) {
    return <SetupWizard onConfigured={check} />;
  }

  return <>{children}</>;
}